<template>
  <div pageD :style="{backgroundImage:`url('${getBg()}')`}">
    <article class="wrapper">
      <div class="cover">
        <div class="cont">
          <slider ref="slide" :option="option" :pagination="false" :navigation="false" >
            <div class="swiper-slide" v-for="(item,id) in pcSlide" :key="id">
              <div class="box">
                <p class=" title" :style="{backgroundImage:`url('${getImage(item.title)}')`}"></p>
                <ul class="tab" v-if="env === 'mob'">
                  <li :class="{on:step===1}"><a @click="setChangeStep(1)">5vs5</a></li>
                  <li :class="{on:step===2}"><a @click="setChangeStep(2)">10vs10</a></li>
                  <li :class="{on:step===3}"><a @click="setChangeStep(3)">20vs20</a></li>
                  <li :class="{on:step===4}"><a @click="setChangeStep(4)">20vs1vs20</a></li>
                </ul>
                <p class="thumb" :style="{backgroundImage:`url('${getImage(item.img)}')`}"></p>
                <a class="btn-play" @click="setMovOn(item.mov,id)"></a>
              </div>
              <p class="bg" :style="{backgroundImage:`url('${getImage(item.bg)}')`}"></p>
            </div>
          </slider>
          <ul class="page-bts">
            <li><a @click="goNext(false)"></a></li>
            <li><a @click="goNext(true)"></a></li>
          </ul>
        </div>
      </div>
    </article>
    <article class="tab-bts" v-if="env === 'pc'">
      <ul>
        <li :class="{on:step===1}"><a @click="setChangeStep(1)"></a></li>
        <li :class="{on:step===2}"><a @click="setChangeStep(2)"></a></li>
        <li :class="{on:step===3}"><a @click="setChangeStep(3)"></a></li>
        <li :class="{on:step===4}"><a @click="setChangeStep(4)"></a></li>
      </ul>
    </article>
  </div>
</template>

<script>
import Slider from '../components/Slider.vue';

export default {
  name: 'pageD',
  components: { Slider },
  data() {
    return {
      step: 1,
      imgUrl: '/static/img/',
      option: {
        loop: false,
        effect: 'fade',
        on: {
          slideChange: this.slideChange,
        },
      },
      pcSlide: [
        {
          bg: 'bg1.jpg', title: 'ct1.png', img: 'c1.png', mov: 'IyE-H-IGI0Y',
        },
        {
          bg: 'bg2.jpg', title: 'ct2.png', img: 'c2.png', mov: 'KCp6vDna83w',
        },
        {
          bg: 'bg3.jpg', title: 'ct3.png', img: 'c3.png', mov: 'wDabB_XwbBs',
        },
        {
          bg: 'bg4.jpg', title: 'ct4.png', img: 'c4.png', mov: 'DOtrpBnJHH4',
        },
      ],
    };
  },
  watch: {
    $route() {
      this.reset();
    },
  },
  computed: {
    env() {
      return this.$store.state.environment;
    },
  },
  methods: {

    setMovOn(mov, id) {
      if (mov === null) {
        this.$store.commit('onMsg', 'Coming Soon!');
        return;
      }
      this.$store.commit('onMov', `https://www.youtube.com/embed/${mov}`);

      switch (id) {
        case 0:
          window.gtag('event', 'click', { event_category: '5vs5' });
          break;
        case 1:
          window.gtag('event', 'click', { event_category: '10vs10' });
          break;
        case 2:
          window.gtag('event', 'click', { event_category: '20vs20' });
          break;
        case 3:
          window.gtag('event', 'click', { event_category: '20vs1vs20' });
          break;
        default:
          break;
      }
    },

    reset() {
      if (this.$route.name === 'war' && this.$route.query.reset === 'Y' && this.$refs.slide) {
        let c = (Number(this.$route.query.code) - 1) || this.step;
        c = c > this.limit - 1 ? this.limit - 1 : c < 0 ? 0 : c;
        this.setChangeStep((Number(this.$route.query.code)) || this.step);
      }
    },

    goNext(next) {
      let step = this.step + (next ? 1 : -1);
      step = next && step > this.pcSlide.length ? 1 : !next && step < 1 ? this.pcSlide.length : step;
      this.setChangeStep(step % (this.pcSlide.length + 1));
    },

    getBg() {
      return `${this.imgUrl}${this.env}/p4/bg${this.step}.jpg`;
    },
    getImage(item) {
      return `${this.imgUrl}${this.env}/p4/${item}`;
    },
    setChangeStep(id) {
      this.step = id;
      this.$refs.slide.goToSlide(this.step - 1);
      if (this.$route.name === 'war' && this.env === 'mob') {
        this.$router.replace(`war?code=${id}&reset=Y`);
      }
    },

    slideChange() {
      this.step = this.$refs.slide.now() + 1;
    },
  },
  mounted() {
    setTimeout(() => {
      this.reset();
    }, 60);
  },
};
</script>

<style lang="less">
  @import '../less/proj';
  .mob{
    [pageD]{.rel; .cover;
      >.wrapper{
        .cover{
          .cont{
            .swiper-container{ .wh(100%,1420);
              .swiper-wrapper{.wh(100%);
                .swiper-slide{ .wh(100%); .rel;
                  .box{ .wh(100% ,950); .l(50%); .t(50%); transform: translate(-50%,-55%); .abs; z-index: 10;
                    .title{.wh(340,90); .contain; .mh-c; .mb(28); .no-repeat;}
                    .thumb{.wh(600,826); .contain; .mh-c; box-shadow: 5px 10px 10px 5px rgba(0,0,0,0.6); .no-repeat; }
                    .btn-play{.abs; .wh(120); .block; .t(300); .l(50%); .ml(-60); }
                    .tab{ .wh(600,54); .ib-list; white-space: nowrap; .mh-c; .mb(24);
                      li{.wh(24.7%,100%); background: rgba(175,39,43,0.5); .mr(.4%); .fs(20); .tc; .lh(54);
                        &.on{background: rgba(175,39,43,1);}
                      }
                    }
                  }
                  .bg{.cover; .wh(100%); .bg-x(50%); .abs; .t(0); .l(0); }
                }
              }
            }
          }
        }
      }
    }
  }
  .pc{
    [pageD]{.fix; .cover("@{pc}/p4/bg1.png"); .bg-x(50%); .wh(100%); .-box; .min-h(100%); .-box; .min-w(1140px); transition: .5s;
      >.wrapper{.w(100%); .abs; .t(85px); .b(78px);
        .cover{.wh(100%); .rel; overflow-y:auto; overflow-x:hidden; -webkit-overflow-scrolling: touch;
          .cont{ .rel; .wh(100%); overflow:hidden; .min-h(1000px);
            .swiper-container{ .wh(100%);
              .swiper-wrapper{.wh(100%);
                .swiper-slide{ .wh(100%); .rel;opacity: 0;
                  .box{ .wh(100%,750px); .abs; .l(50%); .t(50%); transform: translate(-50%,-50%); .p(50px,0); z-index: 10;
                    .title{.wh(283px,72px); .mh-c; .mb(10); .contain;}
                    .thumb{.wh(817px,631px); .mh-c; box-shadow: 3px 10px 10px 5px rgba(0,0,0,0.6); .no-repeat; .contain;}
                    .btn-play{.abs; .wh(150px); .block; .t(50%); .l(50%); .mt(-100px); .ml(-75px);}
                  }
                  .bg{.cover; .wh(100%); .abs; .bg-x(50%);}
                }
              }
            }
          }
        }
      }

      .tab-bts{ .h(45);
        ul{ .ml(-374px);
          li{
            a{.block;.wh(100%);}
            &:nth-of-type(1){.contain("@{pc}/p4/btn-tab1.png"); .wh(186px,100%); .l(0);
              &.on, &:hover{.contain("@{pc}/p4/btn-tab1-on.png");}
            }
            &:nth-of-type(2){.contain("@{pc}/p4/btn-tab2.png"); .wh(203px,100%); .l(178px);
              &.on, &:hover{.contain("@{pc}/p4/btn-tab2-on.png");}
            }
            &:nth-of-type(3){.contain("@{pc}/p4/btn-tab3.png"); .wh(202px,100%); .l(367px);
              &.on, &:hover{.contain("@{pc}/p4/btn-tab3-on.png");}
            }
            &:nth-of-type(4){.contain("@{pc}/p4/btn-tab4.png"); .wh(197px,100%); .l(556px);
              &.on, &:hover{.contain("@{pc}/p4/btn-tab4-on.png");}
            }
          }
        }
      }

      @media screen and (max-width: @screen-xxl-min){
        >.wrapper{.t(63px); .b(56px);}
        .tab-bts{
          ul{ .ml(-254px);
            li{
              &:nth-of-type(1){.wh(124px,100%);}
              &:nth-of-type(2){.wh(135px,100%); .l(119px);}
              &:nth-of-type(3){.wh(134px,100%); .l(245px);}
              &:nth-of-type(4){.wh(131px,100%); .l(371px);}
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pageD.vue